<template>
    <div>
        <component :is="currentComponent" />
    </div>
</template>

<script>
import Top from '@/views/Top.vue'
import Top4Member from '@/views/Top4Member.vue'
import Top4BeautyOEM from '@/views/Top4BeautyOEM.vue'
import firebase from 'firebase/app'
import oemConfigs from '@/plugins/oem'

// OEM種別 → トップコンポーネントのマッピング
// 新しいOEMを追加する場合はここにimportとマッピングを追記する
const OEM_TOP_COMPONENTS = {
  Top4BeautyOEM
}

const SITE_OEM = process.env.VUE_APP_SITE_OEM
const oemTopComponentName = SITE_OEM && oemConfigs[SITE_OEM]
  ? oemConfigs[SITE_OEM].topComponent
  : null

export default {
  name: 'TopCommon',
  components: {
    Top,
    Top4Member,
    ...OEM_TOP_COMPONENTS
  },
  data () {
    return {
      currentComponent: Top
    }
  },
  created () {
    if (oemTopComponentName) {
      this.currentComponent = oemTopComponentName
    } else {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.currentComponent = 'Top4Member'
        } else {
          this.currentComponent = 'Top'
        }
      })
    }
  }
}
</script>
